export enum TimeSinceUpdated {
  MONTHS_6 = '6',
  MONTHS_12 = '12',
  ALL_TIME = '-1',
}
